// Прилипающая при скролле мобильная шапка.
//
// Отдельный виджет, а не общий stickyHeader: тот следит за самим элементом, но
// у мобильной шапки класс is-stuck меняет отступы. У верха страницы шапка
// встаёт вплотную к краю, и наблюдение за ней самой зацикливается — is-stuck
// больше не снимается.
export default function stickyMobileHeader(element) {
    // Маркер в естественной позиции шапки. Он же резервирует верхний зазор
    // (высота в CSS = --page-margin), поэтому его нижняя граница совпадает с той
    // точкой, где шапка прилипает к верху окна. Значит момент прилипания — это
    // момент, когда маркер полностью ушёл за верхний край окна.
    const sentinel = document.createElement("div");
    sentinel.className = "mobile-header-sentinel";
    sentinel.setAttribute("aria-hidden", "true");
    element.parentNode.insertBefore(sentinel, element);

    // Следим за маркером, а не за самой шапкой (её отступы меняет is-stuck).
    // IntersectionObserver сам пересчитывает состояние при загрузке — в том
    // числе если страница открыта уже прокрученной, — при скролле и ресайзе,
    // так что ручной замер смещения не нужен и не может «залипнуть».
    const observer = new IntersectionObserver(
        ([entry]) => {
            element.classList.toggle("is-stuck", !entry.isIntersecting);
        },
        { threshold: [0] }
    );
    observer.observe(sentinel);

    // Прячем шапку при скролле вниз, показываем при скролле вверх. У самого верха
    // страницы держим её видимой всегда.
    const ALWAYS_VISIBLE_ZONE = 90; // px от верха, где шапка не прячется
    const THRESHOLD = 10; // порог чувствительности, чтобы не дёргалась на мелких сдвигах

    let lastScroll = window.scrollY;

    const onScroll = () => {
        const current = window.scrollY;

        if (current < ALWAYS_VISIBLE_ZONE) {
            element.classList.remove("is-hidden");
            lastScroll = current;
            return;
        }

        const delta = current - lastScroll;
        if (Math.abs(delta) < THRESHOLD) return;

        element.classList.toggle("is-hidden", delta > 0);
        lastScroll = current;
    };

    window.addEventListener("scroll", onScroll, { passive: true });
}
